export const ORGANIZATION_TYPE_OPTIONS = [
  {
    key: '2',
    value: 'Corporate Learning and Development (L&D)',
  },
  {
    key: '1',
    value: 'Continuous Professional Development (CPD)',
  },
  {
    key: '0',
    value: 'Educational Institution',
  },
  {
    key: '3',
    value: 'Other',
  },
];

export const LLM_PROVIDER_OPTIONS = [
  {
    key: 'openai',
    value: 'OpenAI',
  },
  {
    key: 'google',
    value: 'Google Gemini',
  },
];
